'use client'

import { GenericNotFound } from '@/dc-shared-web/src'
import { useEnvContext } from 'next-runtime-env'

export default function NotFound() {
  const { NEXT_PUBLIC_DCRUNCH_API_URL } = useEnvContext()

  return <GenericNotFound redirectURL={NEXT_PUBLIC_DCRUNCH_API_URL as string} />
}
